import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconWallet = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8889 5.25C17.1163 5.25 18.1086 6.23313 18.1892 7.46321L18.1944 7.625V8.16499C19.0514 8.45194 19.6814 9.23396 19.7447 10.1714L19.75 10.3275V17.375C19.75 18.6252 18.8089 19.6604 17.6032 19.7445L17.4444 19.75H6.55556C5.3281 19.75 4.33584 18.7669 4.25528 17.5368L4.25 17.375V10.1312V10.101V7.625C4.25 6.37483 5.19111 5.33961 6.39684 5.25551L6.55556 5.25H15.8889ZM17.4444 9.54776L17.4241 9.54749H8.11111C7.6969 9.54749 7.36111 9.2117 7.36111 8.79749C7.36111 8.41779 7.64327 8.104 8.00934 8.05434L8.11111 8.04749H16.6944V7.625C16.6944 7.17232 16.3807 6.8098 15.9885 6.7567L15.8889 6.75H6.55556C6.15181 6.75 5.80705 7.07771 5.7564 7.51384L5.75 7.625V10.101V10.1312V17.375C5.75 17.8277 6.0637 18.1902 6.45598 18.2433L6.55556 18.25H17.4444C17.8482 18.25 18.193 17.9223 18.2436 17.4862L18.25 17.375V10.3275C18.25 9.93261 17.9566 9.60626 17.5758 9.55461L17.47 9.54749H17.4648L17.4444 9.54776ZM15.5 15C16.3284 15 17 14.3284 17 13.5C17 12.6716 16.3284 12 15.5 12C14.6716 12 14 12.6716 14 13.5C14 14.3284 14.6716 15 15.5 15Z"
        />
      </svg>
    );
  }
);
